







































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import { ContentSetModel } from "../../models/content/content-set.model";
import { StatusType } from "../../enums/StatusType";
import ValidationService from "../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../inversify.config";
import Loader from "@/components/Loader.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";

const ContestSetModule = namespace("contentSetModule");

@Component({
  components: {
    Loader,
    SuccessMessage
  }
})
export default class ContentSetDetails extends Vue {
  @ContestSetModule.Action public updateDetails;

  @Prop() public contentSet: IContentSet;
  @Prop() public loading: boolean;

  private lastSaved: Date | null = null;

  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  private submitForm() {
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        this.updateDetails(this.contentSet).then((result) => {
          if (result) {
            this.lastSaved = new Date();
          }
        });
      }
    });
  }
}
